import React from 'react';
import { useStoreContext } from '../../Contexts/StoreContext';
import MenuMobile from './MenuMobile';
import { useLocation } from 'react-router-dom';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';

const FooterStoreCounter = () => {

    const { currentStore } = useStoreContext();
    const location = useLocation();
    const { getLinkToHome } = useStoreHook();
    const { order } = useCheckoutContext();
    const showFooter = currentStore && 
                        location.pathname !== `${getLinkToHome()}/order/${order?.id}/view`
                        && location.pathname !== `${getLinkToHome()}/order/${order?.id}/placed`;

    return (
        <section className='flex flex-col w-full'>

            {showFooter &&
                <>
                    {/* <FooterLinks /> */}

                    {/* {cartConference?.length > 0 
                        ?   <section className='fixed z-30 flex gap-3 items-center justify-between text-right w-full bottom-0 px-4 py-2 md:p-4 md:hidden text-sm ring-t-1 bg-white/50 ring-white/50 rounded-t-xl'>
                                <ButtonPrimary onClick={() => setShowCartConference(true)} className='relative text-nowrap w-full md:max-w-max gap-2 items-center justify-between'>
                                    <span className='flex gap-0.5 items-center'>{t('store_counter.button_float_check_and_send_label')}</span>
                                    <span className='flex gap-1 items-center'>
                                        <TbArrowBigRightFilled size={20} className='animate-side text-white' />
                                        <span>{getTotalQuantityProductsInConference(cartConference) > 1 ? `${getTotalQuantityProductsInConference(cartConference)} ${t('layout.item_label_plural')}` : `${getTotalQuantityProductsInConference(cartConference)} ${t('layout.item_label_singular')}`}</span>
                                    </span>
                                </ButtonPrimary>
                            </section>
                        :   <MenuMobile />
                    } */}

                        {/* {!showSearchBar && cartConference?.length > 0 && 
                            <section className='fixed z-30 flex gap-3 items-center justify-between text-right w-full bottom-14 p-4 pt-2 md:p-4 md:hidden text-sm ring-t-1 bg-white/50 ring-white/50 rounded-t-xl'>
                                <ButtonPrimary onClick={() => setShowCartConference(true)} className='relative text-nowrap w-full md:max-w-max gap-2 items-center justify-between'>
                                    <span className='flex gap-0.5 items-center'>{t('store_counter.button_float_check_and_send_label')}</span>
                                    <span className='flex gap-1 items-center'>
                                        <TbArrowBigRightFilled size={20} className='animate-side text-white' />
                                        <span>{getTotalQuantityProductsInConference(cartConference) > 1 ? `${getTotalQuantityProductsInConference(cartConference)} ${t('layout.item_label_plural')}` : `${getTotalQuantityProductsInConference(cartConference)} ${t('layout.item_label_singular')}`}</span>
                                    </span>
                                </ButtonPrimary>
                            </section>
                        } */}
                        <MenuMobile />
                </>
            }
        </section>
    )
}

export default FooterStoreCounter;
